(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["op-cart-runtime"] && !Shopify.designMode) return;
  try {
    (() => {
  if (window.OPCart) return;
  const start = () => {
    const configElement = document.getElementById('op-cart-config');
    if (!configElement) return;
    const config = JSON.parse(configElement.textContent);
    const root = window.Shopify?.routes?.root || '/';
    let busy = false;
    let stale = false;
    let refreshing = null;
    let lastFocus = null;
    let noteDraft = null;
    let suggestionRevision = 0;
    let refreshAgain = false;
    let closeTimer;
    const surfaces = () => [...document.querySelectorAll('[data-op-cart-surface]')];
    const dialog = () => document.getElementById('op-cart-dialog');
    const reduced = () => matchMedia('(prefers-reduced-motion: reduce)').matches || document.querySelector('[data-op-motion]')?.dataset.opMotion === 'none';
    const sectionIds = () => surfaces().map(surface => surface.dataset.opSection);
    const status = text => { const node = document.getElementById('op-cart-status'); if (node) node.textContent = text; };
    const setBusy = value => {
      busy = value;
      surfaces().forEach(surface => {
        surface.setAttribute('aria-busy', String(value));
        surface.querySelectorAll('[data-op-content] button, [data-op-input]').forEach(button => {
          button.disabled = value || button.hasAttribute('data-op-fixed-disabled') || (stale && button.name === 'checkout');
        });
      });
    };
    const feedback = (message, retry = false) => {
      surfaces().forEach(surface => {
        const box = surface.querySelector('[data-op-feedback]');
        if (!box) return;
        box.replaceChildren(document.createTextNode(message));
        if (retry) {
          const link = document.createElement('a');
          link.href = config.cartUrl;
          link.textContent = config.retry;
          link.dataset.opRetry = '';
          box.append(link);
        }
        box.hidden = !message;
      });
    };
    const request = async (url, options = {}) => {
      const response = await fetch(url, { credentials: 'same-origin', cache: 'no-store', signal: AbortSignal.timeout(15000), ...options });
      const data = await response.json();
      if (!response.ok) throw new Error(typeof data.description === 'string' ? data.description : config.error);
      return data;
    };
    const render = async sections => {
      const replacements = surfaces().map(surface => {
        const html = sections?.[surface.dataset.opSection];
        if (!html) throw new Error(config.error);
        const parsed = new DOMParser().parseFromString(html, 'text/html');
        const content = parsed.querySelector(`[data-op-content][data-op-mode="${surface.dataset.opCartSurface}"]`);
        if (!content) throw new Error(config.error);
        return { surface, content };
      });
      const active = document.activeElement;
      const focusKey = active?.dataset.opFocus;
      const focusSurface = active?.closest('[data-op-cart-surface]')?.dataset.opCartSurface;
      const update = () => {
        replacements.forEach(({ surface, content }) => {
          const old = surface.querySelector('[data-op-content]');
          const scroll = old.querySelector('.opc-main')?.scrollTop || 0;
          const oldProgress = old.querySelector('.opc-shipping__track span')?.style.getPropertyValue('--opc-progress');
          const noteOpen = !!old.querySelector('[data-op-note-details]')?.open;
          old.replaceWith(content);
          const scrollArea = content.querySelector('.opc-main');
          if (scrollArea) scrollArea.scrollTop = scroll;
          const note = content.querySelector('[data-op-note]');
          if (note && noteDraft !== null) note.value = noteDraft;
          if (noteOpen) content.querySelector('[data-op-note-details]')?.setAttribute('open', '');
          const count = Number(content.dataset.opItems);
          surface.querySelectorAll('[data-op-count]').forEach(node => { node.textContent = count; });
          const bar = content.querySelector('.opc-shipping__track span');
          if (bar && oldProgress && !reduced()) {
            const next = bar.style.getPropertyValue('--opc-progress');
            bar.style.setProperty('--opc-progress', oldProgress);
            requestAnimationFrame(() => requestAnimationFrame(() => bar.style.setProperty('--opc-progress', next)));
          }
          if (focusKey && focusSurface === surface.dataset.opCartSurface) {
            const target = [...content.querySelectorAll('[data-op-focus]')].find(node => node.dataset.opFocus === focusKey);
            if (target) target.focus({ preventScroll: true });
            else (surface.querySelector('[data-op-close]') || surface.querySelector('.opc-checkout') || surface.querySelector('a'))?.focus({ preventScroll: true });
          }
        });
        const count = Number(replacements[0]?.content.dataset.opItems || 0);
        document.querySelectorAll('[data-cart-count], .opgh__cart-count').forEach(node => { node.textContent = count; });
        document.querySelectorAll('.opgh__cart').forEach(link => {
          link.setAttribute('aria-label', `${config.updated}: ${count}`);
          if (!link.querySelector('.opgh__cart-count') && count) {
            const badge = document.createElement('span');
            badge.className = 'opgh__cart-count';
            badge.setAttribute('aria-hidden', 'true');
            badge.textContent = count;
            link.append(badge);
          }
          const badge = link.querySelector('.opgh__cart-count');
          if (badge) badge.hidden = count === 0;
        });
        status(config.updated);
        document.dispatchEvent(new CustomEvent('op:cart:updated', { detail: { item_count: count } }));
      };
      if (document.startViewTransition && !dialog()?.open && !reduced()) {
        await document.startViewTransition(update).updateCallbackDone;
      } else update();
      loadSuggestions();
    };
    const loadSuggestions = async () => {
      const revision = ++suggestionRevision;
      const containers = surfaces().flatMap(surface => [...surface.querySelectorAll('[data-op-recommendations]')]);
      const product = document.querySelector('[data-op-content][data-op-product]')?.dataset.opProduct;
      if (!product || !containers.length) return;
      try {
        const params = new URLSearchParams({ section_id: 'op-cart-recommendations', product_id: product, intent: 'complementary', limit: '10' });
        const response = await fetch(`${root}recommendations/products?${params}`, { signal: AbortSignal.timeout(8000) });
        if (!response.ok) return;
        const html = await response.text();
        const content = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-op-suggestion-list]');
        if (!content || revision !== suggestionRevision) return;
        containers.filter(node => node.isConnected).forEach(node => node.replaceChildren(content.cloneNode(true)));
        setBusy(busy);
      } catch (_) {}
    };
    const getSections = () => request(`${config.cartUrl}?${new URLSearchParams({ sections: sectionIds().join(','), _: Date.now() })}`);
    const refresh = () => {
      if (busy && !refreshing) { refreshAgain = true; return Promise.resolve(false); }
      if (refreshing) { refreshAgain = true; return refreshing; }
      setBusy(true);
      refreshing = (async () => {
        try {
          await render(await getSections());
          stale = false;
          feedback('');
          return true;
        } catch (_) {
          stale = true;
          feedback(config.error, true);
          return false;
        } finally {
          refreshing = null;
          setBusy(false);
          if (refreshAgain) { refreshAgain = false; refresh(); }
        }
      })();
      return refreshing;
    };
    const mutate = async (endpoint, data, successMessage) => {
      if (busy) return false;
      setBusy(true);
      feedback('');
      const noteSent = noteDraft;
      try {
        const result = await request(`${root}cart/${endpoint}.js`, {
          method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ ...data, sections: sectionIds(), sections_url: config.cartUrl })
        });
        if (endpoint === 'update' && data.note !== undefined && noteDraft === noteSent) noteDraft = null;
        try { await render(result.sections); }
        catch (_) { await render(await getSections()); }
        stale = false;
        if (successMessage) {
          document.querySelectorAll('[data-op-note-status]').forEach(node => { node.textContent = successMessage; });
          status(successMessage);
        }
        return true;
      } catch (error) {
        try { await render(await getSections()); stale = false; }
        catch (_) { stale = true; }
        feedback(error.message || config.error, stale);
        return false;
      } finally {
        setBusy(false);
        if (refreshAgain) { refreshAgain = false; refresh(); }
      }
    };
    const open = (shouldRefresh = true) => {
      const node = dialog();
      if (!node || typeof node.showModal !== 'function') { location.assign(config.cartUrl); return; }
      clearTimeout(closeTimer);
      node.classList.remove('is-closing');
      if (!node.open) {
        lastFocus = document.activeElement;
        node.showModal();
        document.documentElement.classList.add('opc-lock');
        document.body.classList.add('cart-sidebar-show');
      }
      if (shouldRefresh) refresh();
    };
    const close = () => {
      const node = dialog();
      if (node?.classList.contains('is-closing')) return;
      const finish = () => {
        node?.close();
        node?.classList.remove('is-closing');
        document.documentElement.classList.remove('opc-lock');
        document.body.classList.remove('cart-sidebar-show');
        if (lastFocus?.isConnected) lastFocus.focus({ preventScroll: true });
      };
      if (reduced() || !node?.open) { finish(); return; }
      node.classList.add('is-closing');
      closeTimer = setTimeout(finish, Math.min(parseFloat(getComputedStyle(node).getPropertyValue('--opc-duration')) || 260, 360));
    };
    const changeQuantity = input => {
      if (busy || !input) return;
      if (!input.checkValidity() || !Number.isInteger(input.valueAsNumber)) {
        feedback(config.invalidQuantity);
        input.reportValidity();
        return;
      }
      mutate('change', { id: input.closest('[data-op-line]').dataset.opLine, quantity: input.valueAsNumber });
    };
    document.addEventListener('click', event => {
      const target = event.target.closest('a, button');
      if (!target) return;
      if (target.matches('[data-cart-sidebar]')) {
        event.preventDefault(); event.stopImmediatePropagation(); open(); return;
      }
      if (target.matches('[data-op-close]')) { event.preventDefault(); close(); return; }
      if (!target.closest('[data-op-cart-surface]')) return;
      if (target.matches('[data-op-retry]')) { event.preventDefault(); refresh(); return; }
      if (target.matches('[data-op-remove], [data-op-quantity], [data-op-add], [data-op-save-note]')) {
        event.preventDefault(); event.stopImmediatePropagation();
        if (busy) return;
        if (target.hasAttribute('data-op-remove')) mutate('change', { id: target.closest('[data-op-line]').dataset.opLine, quantity: 0 });
        if (target.hasAttribute('data-op-quantity')) {
          const input = target.closest('.opc-quantity').querySelector('input');
          const step = Number(input.step) || 1;
          input.value = Number(input.value) + Number(target.dataset.opQuantity) * step;
          changeQuantity(input);
        }
        if (target.hasAttribute('data-op-add')) mutate('add', { items: [{ id: Number(target.dataset.opAdd), quantity: Number(target.dataset.opAddQuantity) || 1 }] });
        if (target.hasAttribute('data-op-save-note')) mutate('update', { note: target.closest('form').querySelector('[data-op-note]').value }, config.saved);
      }
    }, true);
    document.addEventListener('input', event => {
      if (!event.target.matches('[data-op-note]')) return;
      noteDraft = event.target.value;
      document.querySelectorAll('[data-op-note]').forEach(node => { if (node !== event.target) node.value = noteDraft; });
      document.querySelectorAll('[data-op-note-status]').forEach(node => { node.textContent = ''; });
    });
    document.addEventListener('change', event => {
      if (event.target.matches('[data-op-input]')) changeQuantity(event.target);
    });
    document.addEventListener('submit', async event => {
      const form = event.target;
      if (!form.matches('[data-op-form]') || form.dataset.opSubmitting === 'true') return;
      if (busy || stale) { event.preventDefault(); if (stale) refresh(); return; }
      if (event.submitter?.name !== 'checkout' && event.submitter?.name !== 'update') {
        event.preventDefault(); return;
      }
      if (noteDraft !== null) {
        event.preventDefault();
        const mode = form.closest('[data-op-cart-surface]').dataset.opCartSurface;
        const checkout = event.submitter?.name === 'checkout';
        if (!await mutate('update', { note: noteDraft }, config.saved)) return;
        const nextForm = document.querySelector(`[data-op-cart-surface="${mode}"] [data-op-form]`);
        if (nextForm && checkout) {
          nextForm.dataset.opSubmitting = 'true';
          nextForm.requestSubmit(nextForm.querySelector('[name="checkout"]'));
        }
      }
    }, true);
    document.addEventListener('cancel', event => { if (event.target === dialog()) { event.preventDefault(); close(); } }, true);
    document.addEventListener('click', event => {
      const node = dialog();
      if (event.target !== node || !node?.open) return;
      const rect = node.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) close();
    });
    new MutationObserver(() => {
      const requested = document.body.classList.contains('cart-sidebar-show');
      if (requested && !dialog()?.open) open(false);
      if (!requested && dialog()?.open) close();
    }).observe(document.body, { attributes: true, attributeFilter: ['class'] });
    document.addEventListener('shopify:section:select', event => {
      if (event.detail?.sectionId === dialog()?.dataset.opSection) open(false);
    });
    document.addEventListener('shopify:section:load', event => {
      if (event.target.querySelector('#op-cart-dialog') && document.body.classList.contains('cart-sidebar-show')) open(false);
    });
    window.addEventListener('pageshow', event => { if (event.persisted) refresh(); });
    window.OPCart = { open, close, refresh };
    if (document.body.classList.contains('cart-sidebar-show')) open();
    if (document.querySelector('[data-op-cart-surface="page"]')) loadSuggestions();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
  } catch(e) { console.error(e); }
})();

})();
